import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    spoils: [],
    listView: false,
    sortBy: '',
    filterBy: '',
    loadingSpoils: false,
    selectedRecordType: 'Active'
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', '')
      context.commit('modifySpoil', '')
      context.commit('modifyVehicle', '')
      context.commit('modifySite', '')
      context.commit('resetTrips')
    }
  },
  getters: {
    getSpoils: state => state.spoils
  }
}
